module.exports = __webpack_public_path__ + "755ecd3d6a6195a9934db5525ce34d8f.png";